import React from "react";
import clsx from "clsx";

interface CardComponentProps {
    children: React.ReactNode | React.ReactNode[];
    className?: string | boolean;
}

const CardComponent = (props: CardComponentProps) => {
    return (
        <div className={clsx(props.className && props.className, "CardComponent bg-white border-gray-100 p-2 xl:p-3 rounded-[10px] shadow-sm")}>
            {props.children}
        </div>
    );
};

export default CardComponent;
